import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

const UploadFlowDialog = ({ open, onClose, title, actions, children }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={false}
    PaperProps={{
      sx: {
        width: 829,
        maxWidth: '100%',
        minHeight: 454,
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'column',
      },
    }}
  >
    <DialogContent sx={{ p: 0, flex: 1, display: 'flex' }}>
      <Stack spacing={4} alignItems="center" sx={{ flex: 1, width: '100%', pt: '32px', px: '48px', pb: '40px' }}>
        {title}
        <Box sx={{
          flex: 1, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
        >
          {children}
        </Box>
        {actions}
      </Stack>
    </DialogContent>
  </Dialog>
);

UploadFlowDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  actions: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default UploadFlowDialog;
